(function () {
  'use strict';

  // Constructible stylesheets: Chrome 73+, Safari 16.4+. Older browsers keep
  // the current two-line row — same as today, no worse.
  var canAdopt =
    typeof CSSStyleSheet === 'function' &&
    typeof ShadowRoot !== 'undefined' &&
    'adoptedStyleSheets' in ShadowRoot.prototype;
  if (!canAdopt) return;

  var patched = new WeakSet();

  /* Comp 1051:5426 — pill 63.1x31.9, fill #5433eb at 10%, stroke #5433eb
     0.665px, fully rounded; wordmark 1051:5427 31.2x12.8.
     The stroke is rounded up to 1px and softened with alpha instead: sub-0.8px
     strokes break up in Chrome at 1x (figma-ref rule 4). */
  /* The hover/active/focus selectors are belt-and-braces, not a bug fix. The
     vendor swaps this div to solid purple via
     `.group:hover .group-hover_bg-purple-d0`, but that declaration is normal
     weight and `!important` already beats it regardless of specificity —
     verified on a real device with CDP forcePseudoState: background, border,
     text colour and outline are byte-identical across normal/hover/active.
     Naming the states explicitly costs nothing and keeps the pill pinned if a
     future vendor build promotes that rule to !important, where specificity
     (theirs 0,2,0 vs ours 0,0,2) would otherwise decide it. */
  var COMP_COLOURS =
    'button > div:first-child,' +
    'button:hover > div:first-child,' +
    'button:active > div:first-child,' +
    'button:focus > div:first-child,' +
    'button:focus-within > div:first-child {' +
    '  background-color: rgba(84, 51, 235, 0.1) !important;' +
    '  border: 1px solid rgba(84, 51, 235, 0.65) !important;' +
    '  box-sizing: border-box !important;' +
    /* Pin the pill to the button box. This div is the visible pill: it is
       `absolute` with `inset-y-0` and `w-full`, but the vendor sets NO left or
       right — so its horizontal origin is its STATIC position, which sits
       after the button's padding-left. The vendor button has no inline padding
       of its own (its spacing comes from the children's px-2/pr-3), so that
       origin was 0 and it lined up. Adding padding-inline below moved the
       static position 15.95px right, dragging the pill off the wordmark and
       leaving dead space on the right — visible on a real device as a
       "broken" badge with the text hanging off its left edge.
       left/right:0 makes it span the padding box regardless. */
    '  left: 0 !important;' +
    '  right: 0 !important;' +
    '  width: auto !important;' +
    '}' +
    'button > span,' +
    'button:hover > span,' +
    'button:active > span { color: #5433eb !important; }';

  /* Geometry. 12.8px tall on a 60x25 viewBox gives a 30.7px wordmark, which
     with 15.95px of padding either side lands the pill at 62.6 — within half
     a pixel of the comp's 63.1. font-size:0 collapses the "Follow on " text
     node while leaving the wordmark <svg> (sized here) untouched. */
  var COMPACT =
    'button {' +
    '  height: 31.9px !important;' +
    '  padding-inline: 15.95px !important;' +
    '}' +
    /* heart glyph — the comp has no icon in this pill */
    'button > div:nth-child(2) { display: none !important; }' +
    'button > span {' +
    '  font-size: 0 !important;' +
    '  padding-right: 0 !important;' +
    '}' +
    'button > span > svg {' +
    '  height: 12.8px !important;' +
    '  width: auto !important;' +
    '}';

  function structureMatches(root) {
    var btn = root.querySelector('button');
    if (!btn) return false;
    var kids = btn.children;
    if (kids.length < 3) return false;
    if (kids[0].tagName !== 'DIV' || kids[1].tagName !== 'DIV') return false;
    var span = btn.querySelector(':scope > span');
    if (!span || !span.querySelector('svg')) return false;
    // the leading text node we intend to collapse
    var first = span.childNodes[0];
    return !!first && first.nodeType === 3 && /follow/i.test(first.nodeValue || '');
  }

  function patch(host) {
    if (patched.has(host)) return true;
    var root = host.shadowRoot;
    if (!root) return false;
    // NOT a permanent bail. The component upgrades in stages: shadowRoot
    // appears BEFORE its contents render, so a structure miss here usually
    // means "not ready yet", not "Shopify reshaped it". Treating the two the
    // same disables the patch during the component's own render gap — which
    // is exactly what happened on the first cut of this file. Retrying until
    // the poller's budget runs out distinguishes them: a genuine redesign
    // simply never matches, and we stop when the budget does.
    if (!structureMatches(root)) return false;
    var sheet = new CSSStyleSheet();
    sheet.replaceSync(COMPACT + COMP_COLOURS);
    // Append — never replace. Clobbering the vendor's own sheet strips the
    // component's base styling and leaves it worse than untouched.
    root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    patched.add(host);
    return true;
  }

  // The component upgrades from a deferred module script, so its shadowRoot
  // usually does not exist yet at parse time. Poll briefly, then give up.
  function run() {
    var hosts = document.querySelectorAll(
      '.sp-footer__shop-follow shop-follow-button'
    );
    if (!hosts.length) return false;
    var all = true;
    for (var i = 0; i < hosts.length; i++) {
      if (!patch(hosts[i])) all = false;
    }
    return all;
  }

  if (run()) return;

  // Poll fast, not leisurely. Until this lands the vendor button renders at its
  // full 158x36 and the row is two lines tall, so every millisecond of delay is
  // a visible snap when it finally applies. 60ms keeps that below the threshold
  // where it reads as a layout jump, and the budget still covers a slow
  // component upgrade. Also retry once the element is defined, which is usually
  // sooner than the next tick.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (run() || tries > 100) clearInterval(timer); // ~6s at 60ms
  }, 60);

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shop-follow-button').then(function () {
      if (run()) clearInterval(timer);
    })['catch'](function () {});
  }
})();
